import React from 'react'
import PropTypes from 'prop-types'

import Image from './Image'
import Caption from './Caption'
import Wrapper from './Wrapper'

const Card  = ({ children, colour, image, to }) => (
	<Wrapper to={to}>
		<Image colour={colour}>
			<img src={image} alt="" />
		</Image>
		<Caption>{children}</Caption>
	</Wrapper>
)

Card.propTypes = {
	children: PropTypes.node.isRequired,
	colour: PropTypes.string,
}

export default Card
